import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=42f90dbf&scoped=true&"
import script from "./courseDetails.vue?vue&type=script&lang=js&"
export * from "./courseDetails.vue?vue&type=script&lang=js&"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=42f90dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f90dbf",
  null
  
)

export default component.exports